export const VALIDATE_TOKEN_SUCCESS = 'VALIDATE_TOKEN_SUCCESS';
export const VALIDATE_TOKEN_FAILURE = 'VALIDATE_TOKEN_FAILURE';

export const CREATE_NPS_SUCCESS = 'CREATE_NPS_SUCCESS';
export const CREATE_NPS_FAILURE = 'CREATE_NPS_FAILURE';

export const UPDATE_NPS_SUCCESS = 'UPDATE_NPS_SUCCESS';
export const UPDATE_NPS_FAILURE = 'UPDATE_NPS_FAILURE';
